import { withTranslation } from 'react-i18next';
import { ListItemIcon, ListItemText, MenuItem, MenuList } from '@mui/material';
import { ReactComponent as NextIcon } from '@public/images/next.svg';
import { ReactComponent as PrivacyIcon } from '@public/images/privacy.svg';
import { usePolicyState } from '@core/myta/components/PolicyModal';
import { useMytaverse } from '@providers/MytaverseProvider';
import { AnalyticsType } from '@interfaces/analytics';
import { useStyles as useStylesMainScreen } from '../MainScreen/styles';
import { useStyles } from './styles';
import { IMore } from './interfaces';

const More = ({ onClose, t: translate }: IMore) => {
  const classesMainScreen = useStylesMainScreen();
  const classes = useStyles();
  const { setOpen: setOpenPrivacy } = usePolicyState();
  const { trackAnalytics } = useMytaverse();

  return (
    <MenuList sx={classesMainScreen.menu}>
      <MenuItem
        sx={classesMainScreen.link}
        onClick={() => {
          setOpenPrivacy(true);
          trackAnalytics(AnalyticsType.ViewPrivacyPolicy, {
            ref: 'menu',
          });
          onClose();
        }}
      >
        <ListItemIcon>
          <PrivacyIcon />
        </ListItemIcon>
        <ListItemText
          sx={{ ...classesMainScreen.linkText, ...classes.linkText }}
        >
          {translate('userProfile.privacyPolicyTerms')}
        </ListItemText>
        <NextIcon />
      </MenuItem>
    </MenuList>
  );
};

export default withTranslation()(More);
